import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const REMOVE_NOTE_TAB_MUTATION = gql `
  mutation Admin_RemoveNoteTab($noteTabID: ID!) {
    ep_removeNoteTab(noteTabID: $noteTabID)
  }
`;
export function useRemoveNoteTabMutation(options) {
    return useGQLMutation(REMOVE_NOTE_TAB_MUTATION, {
        ...options,
        animateOnSuccess: true,
        update(cache, { data }, { variables, context }) {
            if (data?.ep_removeNoteTab && variables?.noteTabID && context?.noteID) {
                cache.modify({
                    id: cache.identify({
                        __typename: 'EPNote',
                        id: context.noteID,
                    }),
                    fields: {
                        tabs(existingTabs) {
                            return existingTabs.filter((tab) => tab.id !== variables.noteTabID);
                        },
                    },
                });
                cache.evict({
                    id: cache.identify({
                        __typename: 'EPNoteTab',
                        id: variables.noteTabID,
                    }),
                });
                cache.gc();
            }
        }
    });
}
